import React from 'react';

export const useComponentWillMount = (cb : () => void) => {
    const willMount = React.useRef(true)

    if (willMount.current) cb()

    willMount.current = false
}